export default __webpack_public_path__ + "static/media/alphabet-yellow-question.199f90bd.png";